<template>
  <div class="flex min-h-full flex-1 flex-col justify-center px-6 pt-24 sm:px-6 lg:px-8">
    <div class="mx-auto w-full max-w-sm">
      <WordmarkLogo class="mx-auto" />
    </div>

    <div class="mx-auto mt-8 flex w-full max-w-sm flex-col gap-6 text-center">
      <h1 class="text-xl font-semibold">{{ t("msg.loggedOut.title") }}</h1>
      <p class="text-sm text-muted-foreground">{{ t("msg.loggedOut.description") }}</p>

      <a
        href="/api/login/saml"
        :class="globals.btnClass(theme, highAccessibility)"
        class="flex w-full items-center justify-center rounded-md px-3 py-2.5 text-sm font-semibold leading-6 text-white shadow-sm"
      >
        {{ t("msg.loggedOut.loginAgain") }}
      </a>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";

import globals from "../globals";
import WordmarkLogo from "../components/WordmarkLogo.vue";
import { useThemeStore } from "../pinia/theme.ts";
import { isNativePlatform } from "../capacitor/platform";

const { t } = useI18n();
const router = useRouter();

const themeStore = useThemeStore();
themeStore.fetchTheme();

const theme = computed(() => themeStore.accent);
const highAccessibility = computed(() => themeStore.highAccessibility);

// The SPA-shell SAML loop this page guards against is web-only.
onMounted(() => {
  if (isNativePlatform()) {
    router.replace("/");
  }
});
</script>
